import { atom } from "jotai";

export const SelectedStudyAtom = atom<boolean | null>(null);
